import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  IAPIListResult,
  IPagination,
  IPaginationResult,
  IPaginationResult2,
  IRequestResult,
  IResult,
} from "../../../../../common/interfaces";
import { environment as env } from "../../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";
import { IUpdateSubRoute } from "../interfaces/update-sub-route.interface";
import {
  MastersUserAttributes,
  default as MaterialStockAttributes,
  UsersLoginAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { ICreateMasterUser } from "./interfaces/user-master.interface";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  CombinedFilter,
  include,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";

const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "master_user";

export type ComboBoxUserResponse = {
  status: string;
  statusCode: string;
  data: {
    application_ids: string[];
    businessPartnerIds: string;
    businessPartnerName: string;
    email: string;
    externalKeysCode: string;
    masterUserId: string;
    permissionId: string;
    sub_applications_ids: string[];
    username: string;
    _id: string;
  }[];
};

@Injectable({
  providedIn: "root",
})
export class UserMasterService extends AbstractService<
  MastersUserAttributes,
  ICreateMasterUser,
  IUpdateSubRoute
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<ComboBoxUserResponse> {
    const query = buildQuery<MastersUserAttributes>(
      where('_deleted',Ops.eq(false)),
      where(
        "applications_ids" as keyof MastersUserAttributes,
        Ops.in(["66e1c7972d51f26e33c1553d"])
      ),
      andWhere(
        "sub_applications_ids" as keyof MastersUserAttributes,
        Ops.in("66ec55bb62c73fb44fb28540")
      )
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/user?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<ComboBoxUserResponse>(API_URL);
  }

  updateUser(data, id) {
    const API_URL: string = apiUrl + `api/${moduleName}/with_user/${id}`;
    return this.http.patch<any>(API_URL, data);
  }

  //USUARIOS SYSTEM
  /**
   * List
   * @param filter CombinedFilter of related entity -
   * @returns Data list
   */
  getPaginateAllUsers(
    options: IPagination<UsersLoginAttributes>
  ): Observable<IPaginationResult<any>> {
    const query = buildQuery<UsersLoginAttributes>(
      where("username", Ops.like(options.search ?? "", "i")),
      orWhere("email", Ops.like(options.search ?? "", "i")),
      orderBy(
        options.sort ?? "username",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/userWithCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<any>>(API_URL);
  }

  //V2
  getAllPaginateAllUsers(
    options: IPagination<any>
  ): Observable<IPaginationResult2<any>> {
    let query = {
      $and: [],
    };

    if (options.search) {
      query["$and"].push({
        $or: [
          {
            user_login_username: {
              $regex: options.search,
              $options: "i",
            },
          },
          {
            user_login_email: {
              $regex: options.search,
              $options: "i",
            },
          },
          {
            user_login_first_name: {
              $regex: options.search,
              $options: "i",
            },
          },
        ],
      });
    }

    if (query["$and"].length === 0) {
      query["$and"].push({});
    }

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/paginated?page=${options.currentPage ?? 1}&limit=${options.limitPerPage ?? 100}&sort=${String(options.sort) ?? "username"}:${options.sortDirection == "ASC" ? 1 : -1}`;
    return this.http.post<IPaginationResult2<any>>(API_URL, query);
  }

  deleteUser(id: string): Observable<IRequestResult<MastersUserAttributes[]>> {
    const API_URL: string = apiUrl + `api/${moduleName}/user/${id}`;
    return this.http.delete<IRequestResult<MastersUserAttributes[]>>(API_URL);
  }

     /**
   * Find to combo box to trip in monitor
   * @returns Data
   */
 findUserAvailable(
    options: IPagination<MastersUserAttributes>, 
): Observable<IRequestResult<MastersUserAttributes[]>> {
 const query = buildQuery<MastersUserAttributes>(
   where("applications_ids" as keyof MastersUserAttributes, Ops.in(['66e1c7972d51f26e33c1553d'])),
   andWhere("sub_applications_ids" as keyof MastersUserAttributes, Ops.in('66ec55bb62c73fb44fb28540')),
   orWhere("username" as keyof MastersUserAttributes, Ops.like(options.search ?? "", "i")),
 );

 const API_URL: string =
   apiUrl +
   `api/${moduleName}/user/trip?filter=${encodeURIComponent(JSON.stringify(query))}`;
 return this.http.get<IRequestResult<MastersUserAttributes[]>>(API_URL);
}
}
